export const SAVE_EMAIL_SIGN_UP_DATA = 'SAVE_EMAIL_SIGN_UP_DATA';
export const SIGN_UP_FOR_EMAIL_SUCCESS = 'SIGN_UP_FOR_EMAIL_SUCCESS';
export const SIGN_UP_FOR_EMAIL_ERROR = 'SIGN_UP_FOR_EMAIL_ERROR';
export const CHANGE_EMAIL_OPTIN_SOURCE = 'CHANGE_EMAIL_OPTIN_SOURCE';
export const CLEAR_EMAIL_SIGN_UP_FORM = 'CLEAR_EMAIL_SIGN_UP_FORM';
export const SET_EMAIL_SIGNUP_STICKY_STATE = 'SET_EMAIL_SIGNUP_STICKY_STATE';

export function saveEmailSignUpData(formData, component) {
    return {
        type: SAVE_EMAIL_SIGN_UP_DATA,
        meta: {
            component: component
        },
        payload: {
            formData: formData
        }
    };
}

export function signUpForEmailSuccess(component) {
    return {
        type: SIGN_UP_FOR_EMAIL_SUCCESS,
        meta: {
            component: component
        }
    };
}

export function signUpForEmailError(err, component) {
    return {
        type: SIGN_UP_FOR_EMAIL_ERROR,
        meta: {
            component: component
        },
        payload: {
            error: err
        }
    };
}

export function changeEmailOptinSource(storeLocation, source) {
    return {
        type: CHANGE_EMAIL_OPTIN_SOURCE,
        payload: {
            storeLocation: storeLocation,
            optInSource: source
        }
    };
}

export function clearEmailSignUpForm(component) {
    return {
        type: CLEAR_EMAIL_SIGN_UP_FORM,
        meta: {
            component: component
        }
    };
}

export function setEmailSignupStickyState(isFixed) {
    return {
        type: SET_EMAIL_SIGNUP_STICKY_STATE,
        payload: {
            isFixed: isFixed
        }
    };
}
